"use client";

import React, {useEffect, useState} from "react";
import {
    Link,
    Navbar,
    NavbarBrand,
    NavbarContent,
    NavbarItem,
    NavbarMenu,
    NavbarMenuItem,
    NavbarMenuToggle,
} from "@nextui-org/react";


import {useDisclosure} from "@mantine/hooks";
import {ActionIcon, Badge, Button, Center, Chip, Group, Input, Modal, Text, UnstyledButton} from "@mantine/core";
import {signOut} from "next-auth/react";
import {usePathname} from 'next/navigation'
import Image from "next/image";
import {Session} from "@auth/core/types";
import {getServerSession} from "@/service/SessionService";
import {IconBell, IconSearch} from "@tabler/icons-react";
import {loadMyNotificationCount} from "@/service/MyService";
import cx from "clsx";
import IndexSearch from "@/components/user-navbar/index-search";
import {notifications} from "@mantine/notifications";


export function LoginNavbar() {
    const [opened, { open, close }] = useDisclosure(false);
    const pathname = usePathname();

    const [sessionLoading, setSessionLoading] = useState<boolean>(true);
    const [session, setSession] = useState<Session | null>(null);
    useEffect(() => {
        async function fetchSession() {
            const serverSession = await getServerSession();
            setSession(serverSession);
        }
        fetchSession().then(() => setSessionLoading(false));
    }, []);

    return (
        <>
            <Navbar
                isBordered
                maxWidth="xl"
                className="bg-default-50 bg-opacity-30"
                classNames={{
                    item: "data-[active=true]:text-primary",
                    wrapper: "px-4 sm:px-6",
                }}
                height="90px"
            >
                <NavbarBrand>
                    <NavbarMenuToggle className="mr-2 h-6 sm:hidden" />
                    <UnstyledButton component="a" href="/">
                        <Image
                            src="/tcc-logo.png"
                            alt="tcc icon"
                            width={262}
                            height={50}
                        />
                    </UnstyledButton>
                </NavbarBrand>
                <NavbarContent justify="center" ><NavbarItem>
                    <Link aria-current="page" className="text-white" href="/" size="sm">
                        首頁
                    </Link>
                </NavbarItem>
                    <NavbarItem>
                        <Link aria-current="page" className="text-white" href="#" size="sm">
                            最新消息1
                        </Link>
                    </NavbarItem>
                    <NavbarItem>
                        <Link aria-current="page" className="text-white" href="#" size="sm">
                            網站介紹
                        </Link>
                    </NavbarItem>
                    <NavbarItem>
                        <Link aria-current="page" className="text-white" href={"/related-documents"} size="sm">
                            相關文件
                        </Link>
                    </NavbarItem>
                </NavbarContent>
            </Navbar>
        </>
    );
}



export default function UserNavbar() {
    const [opened, { open, close }] = useDisclosure(false);
    const [session, setSession] = useState<Session | null>(null);
    const [sessionLoading, setSessionLoading] = useState<boolean>(true);
    const pathname = usePathname();
    const [notificationCount, setNotificationCount] = useState<number>(-1);
    useEffect(() => {
        async function fetchSession() {
            const serverSession = await getServerSession();
            setSession(serverSession);
            console.log(`0> ${JSON.stringify(serverSession)}`);
        }

        fetchSession().then(() => setSessionLoading(false));
    }, []);

    useEffect(() => {
        if(session !== null){
            loadMyNotificationCount().then( result => setNotificationCount(result));
        }
    }, [session]);

    const openSearchModal = () => {
        open();
    }

    const handleSignOut = async () => {
        try {
            await signOut({
                redirectTo: '/',
                redirect: true
            });
        } catch (error) {
            console.error('Sign out error:', error);
            notifications.show({
                title: '登出失敗',
                message: '無法完成登出操作，請稍後再試',
                color: 'red',
                position: 'top-right',
            });
        }
    }


    return (
        <>
            <Navbar
                isBordered
                maxWidth="xl"
                // className="bg-default-50"
                className="bg-white"
                classNames={{
                    item: "data-[active=true]:text-primary",
                    wrapper: "px-4 sm:px-6",
                }}
                height="70px"
            >

                <NavbarBrand>
                    <NavbarMenuToggle className="mr-2 h-6 sm:hidden" />
                    <UnstyledButton component="a" href="/">
                        <Image
                            src="/tcc-logo.png"
                            alt="tcc icon"
                            width={262}
                            height={50}
                        />
                    </UnstyledButton>
                </NavbarBrand>

                <NavbarContent justify="center" >


                    {/*<NavbarItem>*/}
                    {/*    <Link aria-current="page" color="foreground" href="#" size="sm">*/}
                    {/*        最新消息*/}
                    {/*    </Link>*/}
                    {/*</NavbarItem>*/}
                    <NavbarItem isActive={pathname === '/introduction'}>
                        <Link aria-current="page" color="foreground" href="/introduction" size="sm">
                            網站介紹
                        </Link>
                    </NavbarItem>


                    <NavbarItem isActive={pathname === '/related-documents'}>
                        <Link aria-current="page" color="foreground" href={"/related-documents"} size="sm">
                            相關文件
                        </Link>
                    </NavbarItem>
                    <NavbarItem isActive={pathname === '/calendar'}>
                        <Link aria-current="page" color="foreground" href={"/calendar"} size="sm">
                            活動行事曆
                        </Link>
                    </NavbarItem>
                    <NavbarItem isActive={pathname === '/contact-us'}>
                        <Link aria-current="page" color="foreground" href={"/contact-us"} size="sm">
                            聯絡我們
                        </Link>
                    </NavbarItem>

                    {
                        (!sessionLoading && session !== undefined && session?.user?.role == "user") && (
                            <NavbarItem isActive={pathname === '/dashboard'}>
                                <Link aria-current="page" color="foreground" href={"/dashboard"} size="sm">
                                    個人儀表板
                                </Link>
                            </NavbarItem>
                        )
                    }

                    {
                        (!sessionLoading && session !== undefined && session?.user?.role == "admin") && (
                            <NavbarItem>
                                <Link aria-current="page" color="foreground" href={"/manager"} size="sm">
                                    後台管理
                                </Link>
                            </NavbarItem>
                        )
                    }

                    {
                        pathname !== '/search' && (
                            <NavbarItem>
                                <div className="relative">
                                    <Button rightSection={<IconSearch style={{ width: '70%', height: '70%' }} stroke={1.5} />}
                                            onClick={openSearchModal}
                                            variant="light" radius="xl" size="xs" color={"#072949"}>
                                        活動探索
                                    </Button>
                                </div>
                            </NavbarItem>
                        )
                    }

                    {
                        (!sessionLoading && session !== undefined && session?.user?.role == "user") && (
                            <NavbarItem isActive={pathname === '/notification'}>
                                <Link aria-current="page" color="foreground" href={"/notification"} size="sm">
                                    <div className="relative">
                                        {/*<div className="bg-red-500 w-[6px] h-[6px] rounded-full absolute right-0 top-0"></div>*/}
                                        {
                                            notificationCount > 0 && (
                                                <div className={cx('absolute -top-3', notificationCount >= 10 ? '-right-3' : '-right-2')}>
                                                    <Badge color="red" size="xs">
                                                        {notificationCount >= 10 ? '9+' : notificationCount}
                                                    </Badge>
                                                </div>
                                            )
                                        }
                                        <IconBell/>
                                    </div>
                                </Link>
                            </NavbarItem>
                        )
                    }

                    {
                        (!sessionLoading && (session === undefined || session === null)) && (
                            <NavbarItem>
                                <Link aria-current="page" color="foreground" href={"/login"} size="sm">
                                    登入
                                </Link>
                            </NavbarItem>
                        )
                    }

                    {
                        ((!sessionLoading && session !== undefined && session !== null)) && (
                            <NavbarItem>
                                <Link aria-current="page" color="foreground" size="sm" className="cursor-pointer"
                                      onClick={handleSignOut}
                                >
                                    <Text size="sm" pr="xsz">{session?.user?.name}</Text> ( 登出 )
                                </Link>
                            </NavbarItem>
                        )
                    }
                </NavbarContent>

                {/* Mobile Menu */}
                <NavbarMenu>
                    <NavbarMenuItem>
                        <Link className="w-full" color="foreground" href="#">
                            Dashboard
                        </Link>
                    </NavbarMenuItem>
                    <NavbarMenuItem isActive>
                        <Link aria-current="page" className="w-full" color="primary" href="#">
                            Deployments
                        </Link>
                    </NavbarMenuItem>
                    <NavbarMenuItem>
                        <Link className="w-full" color="foreground" href="#">
                            Analytics
                        </Link>
                    </NavbarMenuItem>
                    <NavbarMenuItem>
                        <Link className="w-full" color="foreground" href="#">
                            Team
                        </Link>
                    </NavbarMenuItem>
                    <NavbarMenuItem>
                        <Link className="w-full" color="foreground" href="#">
                            Settings
                        </Link>
                    </NavbarMenuItem>
                </NavbarMenu>
            </Navbar>

            <IndexSearch opened={opened} close={close} />
        </>
    );
}


